import { useState } from "react";
import ExpandPanel from "./ExpandPanel";
import ServiceWidget from "./ServiceWidget";

export default function MetricsWidget({ bookings }: any) {
  const [isVisible, setVisible] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>([]);
  const [title, setTitle] = useState<any>("");
  const mob = bookings.filter(
    (item: any) => item?.booking_source === "internal:mob"
  );

  const por = bookings.filter(
    (item: any) => item?.booking_source === "internal:web"
  );

  const web = bookings.filter(
    (item: any) => item?.booking_source === "external:web"
  );

  const none = bookings.filter(
    (item: any) => item?.booking_source === undefined
  );

  const getPercent = (filtered: any) => {
    const perc = (filtered / bookings?.length) * 100;
    const roun = Math.round(perc);
    const res = isNaN(roun) ? 0 : roun;
    return res;
  };

  return (
    <>
      <div className="grid grid-cols-12 gap-2">
        <div className="col-span-3 border  bg-white">
          <button
            className="hover:bg-red-50 text-left flex items-center w-full h-full  flex-col sm:flex-row"
            onClick={() => {
              setSelected(por);
              setVisible(true);
              setTitle("From Portal - Bookings");
            }}
          >
            <div className="pl-4 ">Portal</div>
            <div className="pl-4 text-xl text-black flex items-center">
              <span className="font-bold">{por?.length}</span>
              <span className="text-xs ml-2 mt-1 italic">
                ( {getPercent(por?.length)} % )
              </span>
            </div>
          </button>
        </div>
        <div className="col-span-3 border bg-white">
          <button
            className="hover:bg-red-50 text-left flex items-center w-full h-full  flex-col sm:flex-row"
            onClick={() => {
              setSelected(web);
              setVisible(true);
              setTitle("From Website - Bookings");
            }}
          >
            <div className="pl-4 ">Website</div>
            <div className="pl-4 text-xl text-black flex items-center">
              <span className="font-bold">{web?.length}</span>
              <span className="text-xs ml-2 mt-1 italic">
                ( {getPercent(web?.length)} % )
              </span>
            </div>
          </button>
        </div>
        <div className="col-span-3 border bg-white">
          <button
            className="hover:bg-red-50 text-left flex items-center w-full h-full  flex-col sm:flex-row"
            onClick={() => {
              setSelected(mob);
              setVisible(true);
              setTitle("From Mobile - Bookings");
            }}
          >
            <div className="pl-4 ">Mobile</div>
            <div className="pl-4 text-xl text-black flex items-center">
              <span className="font-bold">{mob?.length}</span>
              <span className="text-xs ml-2 mt-1 italic">
                ( {getPercent(mob?.length)} % )
              </span>
            </div>
          </button>
        </div>
        <div className="col-span-3 border bg-white">
          <button
            className="hover:bg-red-50 text-left flex items-center w-full h-full  flex-col sm:flex-row"
            onClick={() => {
              setSelected(none);
              setVisible(true);
              setTitle("None Source - Bookings");
            }}
          >
            <div className="pl-4 ">No Source</div>
            <div className="pl-4 text-xl text-black flex items-center">
              <span className="font-bold">{none?.length}</span>
              <span className="text-xs ml-2 mt-1 italic">
                ( {getPercent(none?.length)} % )
              </span>
            </div>
          </button>
        </div>
        {/* <div className="col-span-3 border border-gray-300 bg-white flex justify-end w-full">
          <ServiceWidget />
        </div> */}
      </div>
      <ExpandPanel
        isVisible={isVisible}
        setVisible={setVisible}
        data={selected}
        title={title}
      />
    </>
  );
}
